import type { ReactNode } from 'react';
import { createContext } from 'react';

interface PageLayoutSlots {
  pageHeaderSlot: ReactNode;
  pageSidebarSlot: ReactNode;
}

interface PageLayoutActions {
  setPageHeaderSlot: (node: ReactNode) => void;
  setPageSidebarSlot: (node: ReactNode) => void;
}
// For reading slot content (used by layout components)
export const PageLayoutSlotContext = createContext<PageLayoutSlots>({
  pageHeaderSlot: null,
  pageSidebarSlot: null,
});

// For writing slot content (used by pages via hooks)
export const PageLayoutContext = createContext<PageLayoutActions>({
  setPageHeaderSlot: () => {},
  setPageSidebarSlot: () => {},
});
